import { FC, useMemo } from 'react'
import { FutureLayerUID, FutureLayer } from 'components/features/future/types'
import { FuturePanePreset } from 'components/features/future/FuturePanePreset/FuturePanePreset'
import * as yup from 'yup'
import { useLayerSelector, extendCommonSchema } from 'components/features/future/helpers'
import { useFormContext } from 'react-hook-form'
import { FutureWhenInput } from 'components/features/future/FutureWhenInput/FutureWhenInput'
import { schemaNumber } from 'schemas/baseSchema'
import { FutureFieldSlider } from 'components/features/future/FutureField/FutureFieldSlider'
import { maskCurrencyFromZero } from 'components/atoms/inputs/maskedInput'
import { useCollectLayerErrors } from 'components/features/future/hooks/useCollectErrors'
import { ObjectSchema } from 'yup'
import { LayerStatus } from 'components/features/future/LayerStatus/LayerStatus'
import { UpdateIncome } from 'components/features/future/FutureLayerPast/UpdateIncome/UpdateIncome'

const LAYER_SLUG = 'income_change' as const
type LayerSlugType = typeof LAYER_SLUG
type LayerType = Extract<FutureLayer, { slug: LayerSlugType }>

const schemaCreator = extendCommonSchema<LayerSlugType>(yup.object({
  new_income: schemaNumber,
}) as ObjectSchema<LayerType>)

type FutureLayerPaneIncomeChangeProps = {
  uid?: FutureLayerUID
  onCancel: () => void
}

export const FutureLayerPaneIncomeChange: FC<FutureLayerPaneIncomeChangeProps> = (props) => {
  const { onCancel, uid } = props
  const layer = useLayerSelector<LayerSlugType>(props)

  return (
    <FuturePanePreset<LayerSlugType>
      layer={ layer }
      slug={ LAYER_SLUG }
      name='Income Change'
      icon='income_change'
      type='event'
      schemaCreator={ schemaCreator }
      onCancel={ onCancel }
    >
      <FormFields uid={ uid } />
    </FuturePanePreset>
  )
}

type FormFieldsProps = {
  uid?: FutureLayerUID
}
const FormFields: FC<FormFieldsProps> = (props) => {
  const { uid } = props
  const { watch } = useFormContext<LayerType>()
  const errors = useCollectLayerErrors<LayerType>()

  const new_income = watch('new_income')
  const pastCardChild = useMemo(() => (
    <UpdateIncome amount={ new_income } />
  ), [new_income])

  const completeChild = useMemo(() => (
    <h1>
      Event Completed
    </h1>
  ), [])

  return (
    <LayerStatus uid={ uid || null } completeContent={ completeChild } pastContent={ pastCardChild } type='event'>
      <FutureWhenInput error={ errors.whenField } />

      <FutureFieldSlider
        label='New Income'
        name='new_income'
        mask={ maskCurrencyFromZero }

        error={ errors.new_income }

        min={ 0 }
        max={ 300000 }
        step={ 2500 }
      />
    </LayerStatus>
  )
}
